import { DesignClient } from 'api/clients/DesignClient'
import { useRootStore } from 'stores/RootStore'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useQueryClient } from 'react-query'
import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { filesKeys } from 'hooks/queries/files/filesKeys'
import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import { useCurrentWorkspaceIdWithProject } from 'hooks/useCurrentWorkspaceIdWithProject'

export const useApplyCaption = ({ fileId }: { fileId: string }) => {
  const { files } = useRootStore()
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceIdWithProject()

  const applyCaption = async (caption: string) => {
    const res = await DesignClient.updateCaptions(fileId, [caption], 0)
    if (res.type === SUCCESS_RESPONSE_TYPE) {
      files.updateAttrs(fileId, { captions: [caption], selected_caption_id: 0 })

      queryClient.setQueriesData<AlmanacFileShowItem | undefined>(
        filesKeys.detail(workspaceId, fileId),
        (old) =>
          old && {
            ...old,
            captions: [caption],
            selected_caption_id: 0,
            scheduled_post: old.scheduled_post ? { ...old.scheduled_post, content: caption } : old.scheduled_post,
          },
      )

      queryClient.invalidateQueries(filesKeys.detail(workspaceId, fileId))
      queryClient.invalidateQueries(calendarKeys.all)
      queryClient.invalidateQueries(calendarKeys.detail(fileId))
      showToastMessage('Caption updated!', 'success', undefined, 2)
    }
  }

  return {
    applyCaption,
  }
}
